import React from 'react';

import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { IChecklistTask } from '@features/Checklist/model/types';
import { Icon, UiButton } from '@shared/ui';

import cls from './TriggerBtn.module.css';

interface ITriggerBtnProps {
    isOpenChecklist: boolean;
    enableNewFeatureChip: boolean;
    checklistData: IChecklistTask[];
    triggerCb: () => void;
    isEditMode: boolean;
    className?: string;
}
export const TriggerBtn = ({
    isOpenChecklist,
    enableNewFeatureChip,
    checklistData,
    triggerCb,
    isEditMode,
    className,
}: ITriggerBtnProps) => {
    const { t } = useTranslation();
    const btnText = isOpenChecklist
        ? t('Checklist.HideChecklistBtn.text')
        : checklistData?.length > 0
        ? t('Checklist.OpenChecklistBtn.hasItems.text')
        : t('Checklist.OpenChecklistBtn.text');

    return (
        <UiButton
            startIcon={<Icon iconName="checklist" width={10} height={12} fill="currentColor" />}
            className={cn(
                cls.ChecklistBtn,
                className,
                checklistData?.length > 0 && !isOpenChecklist && cls.hasChecklistItems,
                isOpenChecklist && cls.openedBtn,
                enableNewFeatureChip && cls.disableBtn
            )}
            btnText={btnText}
            onClick={triggerCb}
            disabled={isEditMode}
        />
    );
};
